import React from 'react';
import EcontextOutcome from 'app/components/OrderPayment/Econtext/EcontextOutcome';

const EcontextResult = () => {
  return <EcontextOutcome />;
};

export default EcontextResult;
